import React from "react";
import { Container } from "semantic-ui-react";
import ProductMenu from "../../components/ProductMenu";
import CategoryChips from "../../components/CategoryChips/CategoryChips";
import Title from "./Title";
import MainSection from "./MainSection";
import styles from "./CategoryPage.module.scss";
import SliderDesigners from "./Slider";

const CategoryPageModule: React.FC = () => {
  return (
    <div className={styles.categorypage}>
      <ProductMenu />
      <CategoryChips />
      <Title />
      <Container>
        <MainSection />
        <SliderDesigners />
      </Container>
    </div>
  );
};

export default CategoryPageModule;
